const firebaseConfig = {
    apiKey: "AIzaSyAN08FqFtTWFXOMjT03uxZ9vP_G6F1Epkk",
    authDomain: "assignment-11-samiun.firebaseapp.com",
    projectId: "assignment-11-samiun",
    storageBucket: "assignment-11-samiun.appspot.com",
    messagingSenderId: "182638608965",
    appId: "1:182638608965:web:cdea055ec7cf4ff0de992c"
};

export default firebaseConfig;